/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
/** Unique tabs using H6 as an anchor **/
/** Unique tabs using H6 as an anchor **/
document.addEventListener('DOMContentLoaded', () => {
  const description = document.querySelector('.product-single__box__block--description');

  if (!description) return;

  const headings = [...description.querySelectorAll('h6')];
  // Check if there are any H6 headings
  if (headings.length > 0) {
    description.insertAdjacentHTML(
      'beforeend',
      '<accordion-group class="unique-tabs u-mt"></accordion-group>'
    );
  }

  const accordionGroup = description.querySelector('accordion-group.unique-tabs');

  // Iterate in reverse order (same as jQuery .get().reverse())
  [...headings].reverse().forEach((heading, index) => {
    const tabName = heading.textContent.trim();
    // Hide the heading
    heading.hidden = true;

    if (!tabName) return;

    let tabContent = '';

    // Collect all siblings until the next H6
    let sibling = heading.nextElementSibling;

    while (sibling && sibling.tagName !== 'H6') {
      tabContent += sibling.outerHTML;
      sibling.hidden = true;
      sibling = sibling.nextElementSibling;
    }

    const details = document.createElement('details');
    details.className = `unique-tab-${index}`;

    details.innerHTML = `
      <summary>
        <h3 class="f-family--body u-large u-text-transform--none u-color-text">
          ${tabName}
        </h3>
        <summary-icon>
          <i class="icon icon--theme icon--plus">
           <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 4L24 44M4 24.0024H44" vector-effect="non-scaling-stroke"></path></svg> 
          </i>
        </summary-icon>
      </summary>
      <details-content>
        <div class="product-single__accordion__item-wrap rte">
          ${tabContent}
        </div>
      </details-content>
    `;

    // Equivalent to jQuery.prepend()
    accordionGroup.prepend(details);
  });
});